import { createContext } from 'react'
import type { UseProfileReturn } from '@/types'

export const profileContext = createContext<UseProfileReturn | undefined>(
  undefined,
)
